<div class="strength-meter">
    <div class="strength-meter-fill"></div>
    <!-- Não é a senha, mas é uma propriedade dela ("fraca"/"forte") amarrada a
         uma sessão identificável. Custa um atributo esconder. -->
    <div class="ion-text-center" data-openreplay-obscured [hidden]="!passwordStrengthText">
        <small>{{passwordStrengthText}}</small>
    </div>
</div>